import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from '../contexts/LanguageContext';

const CertificateIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="9" r="6" />
    <path d="M9 14.5 7.5 21l4.5-2.5L16.5 21 15 14.5" />
  </svg>
);

const BrainIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 4a3.5 3.5 0 0 0-3.5 3.5c-2 .3-3.5 2-3.5 4a4 4 0 0 0 2 3.5A3.5 3.5 0 0 0 10.5 20c.6 0 1.1-.15 1.5-.4.4.25.9.4 1.5.4a3.5 3.5 0 0 0 3.5-5A4 4 0 0 0 19 11.5c0-2-1.5-3.7-3.5-4A3.5 3.5 0 0 0 12 4Z" />
    <path d="M12 4v15.6" />
  </svg>
);

const About: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="section section-alt">
      <Container>
        <Row className="align-items-center g-5">
          <Col md={5} className="text-center">
            <img
              src="images/ellinor_headshot.png"
              alt="Ellinor Kantedal"
              className="about-photo"
            />
          </Col>
          <Col md={7}>
            <div className="ps-md-4">
              <p className="kicker">{t('nav.about')}</p>
              <h2 className="section-title">{t('about.title')}</h2>
              <p className="mb-4">{t('about.description')}</p>
              <h3 className="h5 mb-2">{t('about.expertise')}</h3>
              <p className="text-muted mb-4">{t('about.expertiseDescription')}</p>
              <Row className="g-4">
                <Col sm={6}>
                  <div className="credential">
                    <div className="credential-icon"><CertificateIcon /></div>
                    <div>
                      <h6>{t('about.swedishLicensed')}</h6>
                      <small>{t('about.psychologyProfessional')}</small>
                    </div>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="credential">
                    <div className="credential-icon"><BrainIcon /></div>
                    <div>
                      <h6>{t('about.neuropsychology')}</h6>
                      <small>{t('about.neuropsychologyExperience')}</small>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
